import React from "react";
import Link from "next/link";
import { IOfferMode } from "@nju/data-access-portal-offers";
import { CURRENT_ACTIVE_CLIENT_EMAIL } from "@nju/data-access-sales-user";
import { Icon } from "@nju/icons";
import { salesRoutes } from "@nju/routes";
import { A, Panel, Separator, Text } from "@nju/ui";
interface IStartOrderForClient {
  mode: IOfferMode;
}

export function StartOrderForClient({ mode }: IStartOrderForClient) {
  const cleanStorage = React.useCallback(() => {
    if (mode === "ftth") {
      window.localStorage.removeItem("access_token");
      window.localStorage.removeItem(CURRENT_ACTIVE_CLIENT_EMAIL);
    }
  }, [mode]);

  const redirectUrl =
    mode === "ftth"
      ? salesRoutes.sprawdzDostepnosc.index.get()
      : salesRoutes.zalozKonto.get({ mode: "mobile" });

  const headerText =
    mode === "ftth" ? "nju światłowód" : "nju subskrypcja z TV";

  return (
    <Panel withPadding={false}>
      <Link href={redirectUrl} passHref={true}>
        <A
          className="h-full min-w-[280px]"
          data-cy="sell-nju-fiber-section"
          size="inline"
          variant="simple"
        >
          <div
            className="flex flex-col items-start w-full p-3 from-tablet:p-4"
            onClick={cleanStorage}
          >
            <Text
              size={{
                "@fromTablet": "xl",
                "@onlyMobile": "m",
              }}
              weight="bold"
            >
              sprzedaj {headerText}
            </Text>
            <Separator size="s" tone="invisible" />
            <Icon
              data-cy="sell-nju-fiber"
              height={24}
              name="arrow-right"
              tone="accent"
              width={24}
            />
          </div>
        </A>
      </Link>
    </Panel>
  );
}
